// @flow
import React from 'react';
import classnames from 'classnames';
import styles from './style.css';
import IconLabel from '../../util/IconLabel';
import { commonMessages } from '../../messages/Common';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import CapacitorRipple from '../../capacitor/Ripple';
type OwnProps = {
  className?: string,
  dark?: boolean,
  light?: boolean,
  direction: 'forward' | 'back',
  onClick?: Function,
  intl: IntlShape,
};

const CircularSkipButton = ({ className, dark, light, direction, onClick, intl }: OwnProps) => {
  const componentClassName = classnames(className, {
    [styles.component]: !dark && !light, // only use the default one if these are not specified
    [styles.darkComponent]: dark,
    [styles.lightComponent]: light,
  });
  return (
    <button
      onClick={onClick}
      aria-label={
        direction === 'forward'
          ? intl.formatMessage(commonMessages.forward)
          : intl.formatMessage(commonMessages.back)
      }
    >
      <CapacitorRipple version="center" />
      <IconLabel size="18" name={`skip-${direction}`} className={componentClassName} />
    </button>
  );
};

export default injectIntl(CircularSkipButton);
